'use strict';
import Promise from 'bluebird';
import $ from 'jquery';

const getToken = () => {
	return Promise.resolve($.ajax({
		url: '/stage-ajax/getToken',
		method: 'GET',
		cache: false,
		dataType: 'text'
	}));
}

/**
 * Fetches a CSRF token from the server and optionally sets it to the provided input element.
 *
 * @param {HTMLInputElement} [input] - An optional input element to set the fetched token value.
 * @returns {Promise<string>} A promise that resolves to the fetched token string, or an empty string if the fetch fails.
 */
export async function fetchToken(input) {

	const response = await fetch('/stage-ajax/getToken', {
		method: 'GET',
		cache: 'no-cache',
		headers: {
			'Content-Type': 'text/plain'
		}
	});

	if (!response.ok) {
		return '';
	}

	const token = await response.text();
	if (input) {
		input.value = token;
	}
	return token;
}

export default getToken;

export const updateToken = (token) => {
	if (token) {
		$('input[name="stage_token"], input[name="token"]').val(token);
	}
}

export const refreshStageFormTokens = () => {
	if ($('input[name="stage_token"], input[name="token"]').length) {
		return getToken().tap(token => {
			updateToken(token);
		});
	}
	return Promise.resolve();
}
